import React from 'react'
import { TextField } from '@mui/material'
import { com } from '@eidu/form'
import DraftFieldValue from '../../domain/entity/DraftFieldValue'
import Field = com.eidu.sharedlib.entity.field.Field

export type EntityFormTextDisplayProps = {
  field: Field
  fieldValue: DraftFieldValue | undefined
}

const EntityFormTextDisplay = ({ field, fieldValue }: EntityFormTextDisplayProps) => (
  <TextField disabled required={field.required} label={field.name} value={fieldValue?.value ?? ''} />
)

export default EntityFormTextDisplay
